// Image preloader utility to load all perk images on app start

const perkImages = [
  // Grafiki używane w perkach - podstawowe
  '1szyba.png',
  '2szyby.png', 
  '3szyby.png',
  'aku-plus.png',
  'blenda-lift-RL15.png',
  'blenda-lift-RL30.png',
  'blenda-lift-RL5.png',
  'blenda-standard-F15.png',
  'blenda-standard-F30.png', 
  'blenda-standard-R15.png',
  'blenda-standard-R30.png',
  'blenda-standard-R45.png',
  'blenda.png',
  'ceramika-grafitowa.png',
  'ceramika-jasna-refrabox.png',
  'fusion.png',
  'klamka-classic-czarna.png',
  'klamka-classic-czarna1.png',
  'klamka-classic-srebrna.png',
  'klamka-classic-srebrna1.png',
  'klamka-design-czarna.png',
  'klamka-design-czarna1.png',
  'klamka-design-czarno-srebrna.png',
  'klamka-design-czarno-srebrna1.png',
  'klamka-lift-classic-czarna.png',
  'klamka-lift-classic-srebrna.png',
  'lift.png',
  'standard.png',
  // Grafiki używane w popupach perków - te które rzeczywiście istnieją
  'wariant-lift-pic.png',
  'wariant-std-pic.png'
  // UWAGA: Reszta plików -pic.png z listy w NAZWY_PLIKOW_PERKOW.txt nie istnieje w katalogu
  // Jeśli dodasz te pliki, dopisz je tutaj:
  // 'szyba-x1-pic.png',
  // 'szyba-x2-pic.png', 
  // 'szyba-x3-pic.png',
  // 'ceramika-jasna-pic.png',
  // 'ceramika-ciemna-pic.png',
  // 'klamka-classic-czarna-pic.png',
  // 'klamka-classic-srebrna-pic.png',
  // 'klamka-design-czarna-pic.png',
  // 'klamka-design-czarno-srebrna-pic.png',
  // 'blenda-std-Lic15-pic.png',
  // 'blenda-std-Lic30-pic.png',
  // 'blenda-std-z15-pic.png',
  // 'blenda-std-z30-pic.png',
  // 'blenda-std-z45-pic.png',
  // 'benda-lift-15-pic.png',
  // 'benda-lift-30-pic.png',
  // 'benda-lift-5-pic.png',
  // 'fusion-pic.png'
]

// Detect mobile device
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
    || window.innerWidth <= 768
}

export class ImagePreloader {
  private loadedImages = new Set<string>()
  private failedImages = new Set<string>()
  
  async preloadAllImages(): Promise<void> {
    const mobile = isMobile()
    
    if (mobile) {
      // Na mobile ładuj sekwencyjnie z opóźnieniem żeby nie przeciążyć połączenia
      await this.preloadSequentially()
    } else {
      // Na desktop ładuj równolegle jak dotychczas
      await this.preloadInParallel()
    }
  }
  
  private async preloadSequentially(): Promise<void> {
    console.log('Mobile detected: Loading images sequentially')
    for (const imageName of perkImages) {
      try {
        await this.preloadImage(imageName)
        // Małe opóźnienie między obrazkami żeby nie przeciążyć połączenia
        await new Promise(resolve => setTimeout(resolve, 50))
      } catch (error) {
        console.warn(`Failed to preload ${imageName}:`, error)
      }
    }
  }
  
  private async preloadInParallel(): Promise<void> {
    console.log('Desktop detected: Loading images in parallel')
    const promises = perkImages.map(imageName => this.preloadImage(imageName))
    await Promise.allSettled(promises)
  }
  
  private preloadImage(imageName: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const img = new Image()
      
      img.onload = () => {
        this.loadedImages.add(imageName)
        resolve()
      }
      
      img.onerror = () => {
        this.failedImages.add(imageName)
        reject(new Error(`Failed to load image: ${imageName}`))
      }
      
      img.src = `images/perks/${imageName}`
    })
  }
  
  isImageLoaded(imageName: string): boolean {
    return this.loadedImages.has(imageName)
  }
  
  getLoadedCount(): number {
    return this.loadedImages.size
  }
  
  getTotalCount(): number {
    return perkImages.length
  }
}

export const imagePreloader = new ImagePreloader()